module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_iterators.js
// module id = 89
// module chunks = 40